<template>
  <div class="flex w-full flex-col items-center justify-center space-y-8">
    <IconCheckInCircleFilled class="text-action-success-hi h-[40px] w-[40px]" />

    <div>{{ i18n(translations.csvReady) }}</div>

    <RevButton variant="primary" @click="emit('click')">
      {{ i18n(translations.downloadButton) }}
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { IconCheckInCircleFilled } from '@ds/icons/IconCheckInCircleFilled'

import translations from './DownloadButton.translations'

const i18n = useI18n()

const emit = defineEmits(['click'])
</script>
